import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

import { SpLoaderComponent } from './sp-loader.component';
import { loaderConfig } from './config/loader.config';

@NgModule({
    imports: [CommonModule, NgxUiLoaderModule.forRoot(loaderConfig), SpLoaderComponent],
    exports: [SpLoaderComponent],
})
export class SpLoaderModule {}
